import { mount } from "svelte";
import "./app.css";
import App from "./app.svelte";
import { notNullOrDie } from "@repo/utils";
import type { Page } from "./lib/route.svelte.js";

export function mountApp(pages: Page[]) {
    mount(App, {
        target: notNullOrDie(document.getElementById("app")),
        props: { pages },
    });
}
